import { labelPembayaran } from '../../utils/labelPembayaran';
import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Card,
  CardHeader,
  Chip,
  CircularProgress,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TextField,
  Grid,
  AppBar,
  Toolbar,
  Container,
  Paper,
  Avatar,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  List,
  BottomNavigation,
  BottomNavigationAction,
  useTheme,
  useMediaQuery,
  IconButton,
  Badge,
  Tooltip,
  Snackbar,
  Alert,
} from '@mui/material';
import {
  Notifications as NotificationsIcon,
  Bluetooth as BluetoothIcon,
  HomeOutlined,
  ReceiptOutlined,
  PersonOutlined,
  LogoutOutlined,
  DescriptionOutlined,
} from '@mui/icons-material';
import useSWR from 'swr';
import axios from 'axios';
import { format } from 'date-fns';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { exportStyledExcel, pdfTableTheme } from '../../utils/exportHelpers';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Logout, reset } from '../../fitur/AuthSlice';
import ThermalPrinter from './ThermalPrinter';
import LayoutKasir from './layoutKasir';
import { waktuCabang } from '../../utils/waktuCabang';
import { apiHost } from '../../utils/apiHost';
import { ambilKonfigStruk, barisStrukDariTransaksi } from '../../struk/strukWeb';
import { cetakBrowser } from '../../struk/cetakStruk';

const getApiBaseUrl = () => {
  const protocol = window.location.protocol === 'https:' ? 'https' : 'http';
  const baseUrl = apiHost().replace(/^https?:\/\/+/, '');
  return `${protocol}://${baseUrl}`;
};

const fetcher = (url) => axios.get(url, { withCredentials: true }).then((res) => res.data);

const statusMap = {
  settlement: { label: 'Success', color: 'success' },
  pending: { label: 'Pending', color: 'warning' },
  failure: { label: 'Failed', color: 'error' },
  cancel: { label: 'Canceled', color: 'error' },
};

export const Transaksi = () => {
  const [tanggal, setTanggal] = useState(format(waktuCabang(new Date()), 'yyyy-MM-dd'));
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [currentView, setCurrentView] = useState('history');
  const [branchName, setBranchName] = useState("Nama Toko");
  const [showPrinterSettings, setShowPrinterSettings] = useState(false);
  const [printerConnected, setPrinterConnected] = useState(false);
  const [printerInstance, setPrinterInstance] = useState(null);
  const [notification, setNotification] = useState({ open: false, message: '', severity: 'info' });
  
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const { data: notificationData } = useSWR(
    `${getApiBaseUrl()}/notifications`,
    fetcher,
    { 
      refreshInterval: 30000, 
      revalidateOnFocus: true,
      dedupingInterval: 5000
    }
  );
  const notificationCount = notificationData?.data?.length || 0;

  useEffect(() => {
    // Hari ini menurut zona cabang (bukan jam komputer).
    const today = format(waktuCabang(new Date()), 'yyyy-MM-dd');
    setTanggal(today);
  }, []);

  useEffect(() => {
    const fetchBranchName = async () => {
      try {
        const response = await axios.get(`${getApiBaseUrl()}/me`, { withCredentials: true });
        setBranchName(response.data.cabang?.namacabang || "Nama Toko Tidak Diketahui");
      } catch (err) {
        console.error("Gagal mendapatkan nama cabang:", err);
        setBranchName("Nama Toko Tidak Diketahui");
      }
    };
    fetchBranchName();
  }, []);

  useEffect(() => {
    const path = location.pathname;
    if (path === '/produkpercabang') {
      setCurrentView('home');
    } else if (path === '/transaksikasir') {
      setCurrentView('history');
    } else if (path === '/notification' || path === '/notification-kasir') {
      setCurrentView('notification');
    } else if (path === '/detail' || path === '/detail-kasir') {
      setCurrentView('detail');
    } else if (path === '/profilekasir') {
      setCurrentView('profile');
    }
  }, [location.pathname]);

  const handleNavigate = (path) => {
    navigate(path);
  };

  const handleLogout = () => {
    try {
      dispatch(reset());
      dispatch(Logout());
      navigate('/');
    } catch (error) {
      console.error('Logout error:', error);
      navigate('/');
    }
  };

  const handleNotificationClick = () => {
    navigate('/notification-kasir');
  };

  const { data: rekapData, error: rekapError, isValidating } = useSWR(
    `${getApiBaseUrl()}/rekapharianuser?tanggal=${tanggal}`,
    fetcher
  );
  
  const formatCurrency = (value) => {
    const numValue = parseFloat(value);
    if (isNaN(numValue)) return 'Rp 0';
    return `Rp ${numValue.toLocaleString('id-ID', { minimumFractionDigits: 0 })}`;
  };

  const SalesSummaryCard = () => {
    if (!rekapData) return null;

    const SummaryItem = ({ label, value, highlightColor }) => (
      <Box sx={{ 
        p: 2, 
        borderRadius: '12px',
        backgroundColor: highlightColor || 'white',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
      }}>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          {label}
        </Typography>
        <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#337ab7' }}>
          {formatCurrency(value)}
        </Typography>
      </Box>
    );

    return (
      <Card sx={{ mb: 3, borderRadius: '16px', boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }}>
        <CardHeader 
          title="Rekap Penjualan Hari Ini" 
          subheader={`Tanggal: ${format(new Date(tanggal), 'dd MMMM yyyy')}`}
          sx={{ bgcolor: '#f8f9fa', borderRadius: '16px 16px 0 0' }}
        />
        <Divider />
        <Box sx={{ p: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <SummaryItem 
                label="Total Penjualan Success"
                value={rekapData.totalPenjualanSuccess}
                highlightColor="#e3f2fd"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'bold' }}>
                Pembayaran Cash
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <SummaryItem 
                    label="Cash Success"
                    value={rekapData.totalPenjualanCashSuccess}
                  />
                </Grid>
                <Grid item xs={12}>
                  <SummaryItem 
                    label="Cash Pending"
                    value={rekapData.totalPenjualanCashPending}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'bold' }}>
                Pembayaran QRIS
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <SummaryItem 
                    label="QRIS Success"
                    value={rekapData.totalPenjualanQrisSuccess}
                  />
                </Grid>
                <Grid item xs={12}>
                  <SummaryItem 
                    label="QRIS Pending"
                    value={rekapData.totalPenjualanQrisPending}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'bold' }}>
                Pembayaran Non Cash
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <SummaryItem
                    label="Non Cash Success"
                    value={rekapData.totalPenjualanNonCashSuccess}
                  />
                </Grid>
                <Grid item xs={12}>
                  <SummaryItem
                    label="Non Cash Pending"
                    value={rekapData.totalPenjualanNonCashPending}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <SummaryItem
                label="Total Penjualan Pending"
                value={rekapData.totalPenjualanPending}
                highlightColor="#fff3e0"
              />
            </Grid>
          </Grid>
        </Box>
      </Card>
    );
  };

  // Cetak ulang nota satu transaksi: tata letak SAMA dengan struk kasir (struk/strukLayout.js, juga dipakai Flutter).
  const cetakDetailStruk = async (trx) => {
    const { cabangConfig, logoUrl } = await ambilKonfigStruk(axios, getApiBaseUrl(), user?.cabang?.uuid);
    cetakBrowser(barisStrukDariTransaksi({ trx, cabangConfig, logoUrl }));
  };

  const handlePrint = () => {
    if (rekapData) {
      const transaksiPertama = rekapData.data.transaksiSuccess[0];
      const username = transaksiPertama?.User?.username || 'Tidak diketahui';
      const namacabang = transaksiPertama?.User?.Cabang?.namacabang || 'Tidak diketahui';

      const printWindow = window.open('', '_blank');
      const content = `
        <html>
          <head>
            <style>
              body {
                font-family: Arial, sans-serif;
                font-size: 12px;
                margin: 0;
                padding: 0;
                width: 58mm;
              }
              .container {
                padding: 10px;
                text-align: center;
              }
              h1 {
                font-size: 14px;
                margin-bottom: 5px;
              }
              p {
                margin: 5px 0;
              }
              .line {
                border-top: 1px dashed #000;
                margin: 10px 0;
              }
              .footer {
                margin-top: 10px;
                font-size: 10px;
              }
            </style>
          </head>
          <body>
            <div class="container">
              <h1>Rekap Harian</h1>
              <div class="line"></div>
              <p><strong>Nama Kasir:</strong> ${username}</p>
              <p><strong>Cabang:</strong> ${namacabang}</p>
              <p><strong>Tanggal Rekap:</strong> ${format(new Date(tanggal), 'dd/MM/yyyy')}</p>
              <div class="line"></div>
              <p><strong>Total Penjualan Success:</strong>Rp.${parseFloat(rekapData.totalPenjualanSuccess).toLocaleString()}</p>
              <p><strong>Total Penjualan Pending:</strong>Rp.${parseFloat(rekapData.totalPenjualanPending).toLocaleString()}</p>
              <div class="line"></div>
              <p><strong>Penjualan Detail:</strong></p>
              <p>- Cash Success:Rp.${parseFloat(rekapData.totalPenjualanCashSuccess).toLocaleString()}</p>
              <p>- QRIS Success:Rp. ${parseFloat(rekapData.totalPenjualanQrisSuccess).toLocaleString()}</p>
              <p>- Non Cash Success:Rp. ${parseFloat(rekapData.totalPenjualanNonCashSuccess || 0).toLocaleString()}</p>
              <p>- Cash Pending:Rp.${parseFloat(rekapData.totalPenjualanCashPending).toLocaleString()}</p>
              <p>- QRIS Pending:Rp.${parseFloat(rekapData.totalPenjualanQrisPending).toLocaleString()}</p>
              <p>- Non Cash Pending:Rp. ${parseFloat(rekapData.totalPenjualanNonCashPending || 0).toLocaleString()}</p>
              <div class="line"></div>
              <p class="footer">*Terima kasih atas kerja keras Anda!*</p>
            </div>
          </body>
        </html>
      `;
      printWindow.document.write(content);
      printWindow.document.close();
      printWindow.print();
    }
  };
  
  const handlePrintPdf = () => {
    if (!rekapData) return;

    const doc = new jsPDF();
    const username = rekapData.data.transaksiSuccess[0]?.User?.username || 'Tidak diketahui';
    const namacabang = rekapData.data.transaksiSuccess[0]?.User?.Cabang?.namacabang || 'Tidak diketahui';

    doc.setFontSize(18);
    doc.text("Laporan Rekap Harian", doc.internal.pageSize.getWidth() / 2, 20, { align: 'center' });
    doc.setFontSize(10);
    doc.text(`Tanggal: ${format(new Date(tanggal), 'dd MMMM yyyy')}`, doc.internal.pageSize.getWidth() / 2, 28, { align: 'center' });
    doc.line(10, 35, doc.internal.pageSize.getWidth() - 10, 35);

    doc.setFontSize(12);
    doc.text(`Nama Kasir: ${username}`, 15, 45);
    doc.text(`Cabang: ${namacabang}`, 15, 52);
    doc.text(`Total Penjualan Sukses: ${formatCurrency(rekapData.totalPenjualanSuccess)}`, 15, 62);
    doc.text(`Total Penjualan Pending: ${formatCurrency(rekapData.totalPenjualanPending)}`, 15, 69);
    doc.line(10, 75, doc.internal.pageSize.getWidth() - 10, 75);

    doc.setFontSize(14);
    doc.text("Detail Transaksi Sukses", 15, 85);
    const tableData = rekapData.data.transaksiSuccess.map(tx => [
      tx.order_id,
      format(waktuCabang(tx.createdAt), 'HH:mm:ss'),
      tx.pembayaran,
      formatCurrency(tx.totaljual),
    ]);
    doc.autoTable({
      startY: 90,
      head: [['Order ID', 'Waktu', 'Pembayaran', 'Total']],
      body: tableData,
      styles: { fontSize: 10, cellPadding: 2, overflow: 'ellipsize' },
      ...pdfTableTheme,
      margin: { left: 15, right: 15 },
    });

    const finalY = doc.autoTable.previous.finalY;

    doc.setFontSize(12);
    doc.text("Ringkasan Pembayaran:", 15, finalY + 15);
    doc.text(`- Cash Sukses: ${formatCurrency(rekapData.totalPenjualanCashSuccess)}`, 20, finalY + 22);
    doc.text(`- QRIS Sukses: ${formatCurrency(rekapData.totalPenjualanQrisSuccess)}`, 20, finalY + 29);
    doc.text(`- Non Cash Sukses: ${formatCurrency(rekapData.totalPenjualanNonCashSuccess || 0)}`, 20, finalY + 36);
    doc.text(`- Cash Pending: ${formatCurrency(rekapData.totalPenjualanCashPending)}`, 20, finalY + 43);
    doc.text(`- QRIS Pending: ${formatCurrency(rekapData.totalPenjualanQrisPending)}`, 20, finalY + 50);
    doc.text(`- Non Cash Pending: ${formatCurrency(rekapData.totalPenjualanNonCashPending || 0)}`, 20, finalY + 57);

    doc.line(10, finalY + 64, doc.internal.pageSize.getWidth() - 10, finalY + 64);
    doc.setFontSize(10);
    doc.text("Laporan ini dicetak secara otomatis", doc.internal.pageSize.getWidth() / 2, finalY + 69, { align: 'center' });

    doc.save(`rekap-harian-${tanggal}.pdf`);
  };

  const handleExportExcel = async () => {
    if (!rekapData) return;
    const rows = rekapData.data.transaksiSuccess.map(tx => [
      tx.order_id,
      format(waktuCabang(tx.createdAt), 'HH:mm:ss'),
      tx.pembayaran,
      parseFloat(tx.totaljual) || 0,
    ]);

    await exportStyledExcel({
      fileName: `rekap-harian-${tanggal}.xlsx`,
      sheetName: 'Rekap Harian',
      title: 'Laporan Rekap Harian',
      metaRows: [
        ['Tanggal', format(new Date(tanggal), 'dd MMMM yyyy')],
        ['Total Penjualan Sukses', formatCurrency(rekapData.totalPenjualanSuccess)],
        ['Total Penjualan Pending', formatCurrency(rekapData.totalPenjualanPending)],
        ['Cash Sukses / Pending', `${formatCurrency(rekapData.totalPenjualanCashSuccess)} / ${formatCurrency(rekapData.totalPenjualanCashPending)}`],
        ['QRIS Sukses / Pending', `${formatCurrency(rekapData.totalPenjualanQrisSuccess)} / ${formatCurrency(rekapData.totalPenjualanQrisPending)}`],
        ['Non Cash Sukses / Pending', `${formatCurrency(rekapData.totalPenjualanNonCashSuccess || 0)} / ${formatCurrency(rekapData.totalPenjualanNonCashPending || 0)}`],
      ],
      headers: ['Order ID', 'Waktu', 'Pembayaran', 'Total'],
      rows,
      columnWidths: [24, 12, 14, 18],
    });
  };

  const handleRowClick = (transaction) => {
    setSelectedTransaction(transaction);
  };



  return (
    <LayoutKasir
      currentView={currentView}
      onViewChange={setCurrentView}
      onNavigate={handleNavigate}
      onLogout={handleLogout}
      showPrinterSettings={showPrinterSettings}
      onShowPrinterSettings={setShowPrinterSettings}
      printerConnected={printerConnected}
      printerInstance={printerInstance}
      onSetPrinterInstance={setPrinterInstance}
    >
      <Box sx={{ backgroundColor: '#f8f9fa', minHeight: '100vh', pb: isMobile ? 8 : 0 }}>
        <ThermalPrinter 
          open={showPrinterSettings} 
          onClose={() => setShowPrinterSettings(false)}
          onPrinterConnected={(device) => {
            setPrinterInstance(device);
            setPrinterConnected(true);
          }}
          onPrinterDisconnected={() => {
            setPrinterInstance(null);
            setPrinterConnected(false);
          }}
          currentPrinter={printerInstance}
          connectionStatus={printerInstance?.getConnectionStatus?.()}
        />

      {isMobile && (
        <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000 }} elevation={3}>
          <BottomNavigation
            value={currentView}
            onChange={(event, newValue) => {
              if (newValue === 'home') {
                handleNavigate('/produkpercabang');
                setCurrentView('home');
              } else if (newValue === 'history') {
                handleNavigate('/transaksikasir');
                setCurrentView('history');
              } else if (newValue === 'notification') {
                handleNavigate('/notification-kasir');
                setCurrentView('notification');
              } else if (newValue === 'profile') {
                handleNavigate('/profilekasir');
                setCurrentView('profile');
              }
            }}
            showLabels
          >
            <BottomNavigationAction
              label="Home"
              value="home"
              icon={<HomeOutlined />}
            />
            <BottomNavigationAction
              label="Transaksi"
              value="history"
              icon={<ReceiptOutlined />}
            />
            <BottomNavigationAction
              label="Notifikasi"
              value="notification"
              icon={<NotificationsIcon />}
            />
            <BottomNavigationAction
              label="Profile"
              value="profile"
              icon={<PersonOutlined />}
            />
          </BottomNavigation>
        </Paper>
      )}

      <Container 
        maxWidth="lg" 
        sx={{ 
          mt: 3, 
          mb: 3,
          ml: 0,
          transition: 'margin 0.3s ease',
          width: '100%'
        }}
      >
        <Box sx={{ mb: 3, display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'space-between' }}>
          <TextField
            label="Tanggal"
            type="date"
            value={tanggal}
            onChange={(e) => setTanggal(e.target.value)}
            InputLabelProps={{ shrink: true }}
            fullWidth
            sx={{ 
              flex: 1, 
              minWidth: '200px',
              backgroundColor: 'white',
              borderRadius: '12px',
              '& .MuiOutlinedInput-root': {
                borderRadius: '12px',
              }
            }}
          />
          <Button
            variant="contained"
            onClick={handlePrint}
            disabled={!rekapData || isValidating}
            sx={{ 
              minWidth: '150px',
              bgcolor: '#337ab7',
              '&:hover': {
                bgcolor: '#286090',
              },
              borderRadius: '12px'
            }}
          >
            Print Rekap
          </Button>
          <Button
            variant="outlined"
            onClick={handlePrintPdf}
            disabled={!rekapData || isValidating}
            sx={{ 
              minWidth: '150px',
              borderColor: '#337ab7',
              color: '#337ab7',
              '&:hover': {
                borderColor: '#286090',
                bgcolor: '#e8f4fd',
              },
              borderRadius: '12px'
            }}
          >
            Print PDF
          </Button>
          <Button
            variant="outlined"
            onClick={handleExportExcel}
            disabled={!rekapData || isValidating}
            sx={{
              minWidth: '150px',
              borderColor: '#28a745',
              color: '#28a745',
              '&:hover': {
                borderColor: '#218838',
                bgcolor: '#e8f7ec',
              },
              borderRadius: '12px'
            }}
          >
            Export Excel
          </Button>
        </Box>

        {isValidating ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', my: 3 }}>
            <CircularProgress />
          </Box>
        ) : rekapError ? (
          <Alert severity="error" sx={{ my: 3, borderRadius: '12px' }}>
            Gagal memuat data rekap
          </Alert>
        ) : (
          <SalesSummaryCard />
        )}

        <Card sx={{ borderRadius: '16px', boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }}>
          <CardHeader 
            title="Rekap Harian" 
            sx={{ bgcolor: '#f8f9fa', borderRadius: '16px 16px 0 0' }}
          />
          <Divider />
          <Box sx={{ overflowX: 'auto', width: '100%', p: 2 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600 }}>Order ID</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Total Jual</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Status Pembayaran</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Pembayaran</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Tanggal</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Dibuat</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rekapError ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      <Typography color="error">Gagal memuat data rekap harian.</Typography>
                    </TableCell>
                  </TableRow>
                ) : isValidating || !rekapData ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      <CircularProgress size={24} />
                    </TableCell>
                  </TableRow>
                ) : (
                  rekapData?.data?.transaksiSuccess.map((transaction) => (
                    <TableRow
                      key={transaction.uuid}
                      hover
                      sx={{ cursor: 'pointer', '&:hover': { bgcolor: '#f5f5f5' } }}
                      onClick={() => handleRowClick(transaction)}
                    >
                      <TableCell>{transaction.order_id}</TableCell>
                      <TableCell>{formatCurrency(transaction.totaljual)}</TableCell>
                      <TableCell>
                        <Chip
                          label={statusMap[transaction.status_pembayaran]?.label || 'Unknown'}
                          color={statusMap[transaction.status_pembayaran]?.color || 'default'}
                          size="small"
                        />
                      </TableCell>
                      <TableCell>{labelPembayaran(transaction)}</TableCell>
                      <TableCell>{format(new Date(transaction.tanggal), 'dd/MM/yyyy')}</TableCell>
                      <TableCell>{format(waktuCabang(transaction.createdAt), 'HH:mm:ss')}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </Box>
        </Card>

        {selectedTransaction && (
          <Card sx={{ mt: 3, borderRadius: '16px', boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }}>
            <CardHeader 
              title={`Detail Transaksi: ${selectedTransaction.order_id}`}
              sx={{ bgcolor: '#f8f9fa', borderRadius: '16px 16px 0 0' }}
            />
            <Divider />
            <Box sx={{ p: 3 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ mb: 1 }}>
                    <strong>Nama Kasir:</strong> {selectedTransaction.User?.username || 'Tidak diketahui'}
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 1 }}>
                    <strong>Cabang:</strong> {selectedTransaction.User?.Cabang?.namacabang || 'Tidak diketahui'}
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 1 }}>
                    <strong>Tanggal:</strong> {format(new Date(selectedTransaction.tanggal), 'dd/MM/yyyy')}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ mb: 1 }}>
                    <strong>Status Pembayaran:</strong> 
                    <Chip
                      label={statusMap[selectedTransaction.status_pembayaran]?.label || 'Unknown'}
                      color={statusMap[selectedTransaction.status_pembayaran]?.color || 'default'}
                      size="small"
                      sx={{ ml: 1 }}
                    />
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 1 }}>
                    <strong>Pembayaran:</strong> {labelPembayaran(selectedTransaction)}
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 1, color: '#337ab7', fontWeight: 600 }}>
                    <strong>Total:</strong> {formatCurrency(selectedTransaction.totaljual)}
                  </Typography>
                </Grid>
              </Grid>
              <Divider sx={{ my: 2 }} />
              <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
                Detail Barang:
              </Typography>
              {selectedTransaction.TransaksiDetails.map((detail) => (
                <Box key={detail.uuid} sx={{ mb: 1, p: 1, bgcolor: '#f8f9fa', borderRadius: '8px' }}>
                  <Typography variant="body2">
                    {detail.Barang?.namabarang || 'Barang tidak diketahui'} - Jumlah: {detail.jumlahbarang} - Harga: {formatCurrency(detail.harga)} - Total: {formatCurrency(detail.total)}
                  </Typography>
                  {Array.isArray(detail.serialNumbers) && detail.serialNumbers.length > 0 && (
                    <Typography variant="caption" color="text.secondary">
                      Serial: {detail.serialNumbers.join(', ')}
                    </Typography>
                  )}
                </Box>
              ))}
            </Box>
            <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: '0 0 16px 16px' }}>
              <Button
                variant="contained"
                fullWidth
                onClick={() => cetakDetailStruk(selectedTransaction)}
                sx={{
                  bgcolor: '#337ab7',
                  '&:hover': {
                    bgcolor: '#286090',
                  },
                  borderRadius: '12px'
                }}
              >
                Cetak Detail
              </Button>
            </Box>
          </Card>
        )}
      </Container>

      <Snackbar
        open={notification.open}
        autoHideDuration={3000}
        onClose={() => setNotification({ ...notification, open: false })}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setNotification({ ...notification, open: false })}
          severity={notification.severity}
          variant="filled"
          sx={{ borderRadius: '12px' }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
      </Box>
    </LayoutKasir>
  );
};
